import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./FilterComponentStyles";

const AuthorizedPoolFilter = ({
    value,
    onChange,
    disabled = true,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    label = "fields.poolRegion",
    marginBottom = "20px",
    showLabel = true,
    optionFilter = () => true
}) => {
    const {t} = useTranslation(["pools"]);
    const stores = useStore();

    const [poolsLoading, userPools] = useFetch({
        defaultDataValue: {data: []},
        fetchFn: stores.poolStore.getUserPools.bind(null, {}),
        dependencies: [],
        initialCall: initialCall
    });

    const poolList = userPools?.data ?? [];

    const handleChange = newValue => {
        if (Array.isArray(newValue) && newValue.includes("all") && newValue.length > 1) {
            if ((value || []).includes("all")) {
                onChange(newValue.filter(v => v !== "all"));
            } else {
                onChange(["all"]);
            }
            return;
        }
        onChange(newValue);
    };

    return (
        <React.Fragment>
            {showLabel ? (
                <h5>{label ? t(label, {ns: "pools"}) : t("fields.poolRegion", {ns: "pools"})}</h5>
            ) : null}
            <SelectField
                showSearch
                data-testid="authorizedPoolSelect"
                value={value}
                onChange={handleChange}
                disabled={disabled && poolsLoading}
                mode={mode}
                allowClear={allowClear}
                mb={marginBottom}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {poolList.length > 0 &&
                    arrayAlphabeticalSort([...poolList], "name")
                        .filter(optionFilter)
                        .map(pool => (
                            <SelectField.Option
                                key={pool._id}
                                value={pool._id}
                                data-testid="authorizedPoolSelect_option"
                            >
                                {pool.name}
                            </SelectField.Option>
                        ))}
            </SelectField>
        </React.Fragment>
    );
};

export default AuthorizedPoolFilter;
